import axios from '../utils/axios'
import qs from "qs"

// 忘记密码接口
export function apply(params) {
  return axios.post('/api/user/pwd/apply.do', qs.stringify(params));
}
// 修改密码接口
export function change(params) {
  return axios.post('/api/user/pwd/change.do', qs.stringify(params));
}
// 登录
export function login(params) {
  return axios.post('/api/user/login.do', qs.stringify(params));
}
// 登出
export function logout() {
  return axios.post('/api/user/logout.do')
}

// 管理员账号操作
// 管理员获取创建账号基本条件信息
export function getAccountInfo() {
  return axios.get('/api/user/account/add.do')
}

// 管理员创建账号
export function addAccount(params) {
  return axios.post('/api/user/account/add.do', params,
    {
      headers: { 'Content-Type': 'application/json' }
    })
}
// 管理员禁用账号
export function disableAccount(params) {
  return axios.post('/api/user/account/disable.do', qs.stringify(params))
}
// 管理员获取创建账号基本条件信息和当前查看的账号信息
export function getCurrentAccountInfo(username) {
  return axios.get('/api/user/account/edit.do?username='+username)
}

//管理员修改账号基本信息
export function editAccount(params) {
  return axios.post('/api/user/account/edit.do', params,
  {
    headers: { 'Content-Type': 'application/json' }
  })
}

//管理员启用账号
export function enableAccount(params) {
  return axios.post('/api/user/account/enable.do', qs.stringify(params))
}

// 管理员 
export function getApiUserList(params) {
  return axios.post('/api/user/data/list.do', qs.stringify(params));
}

//  管理员重置密码 
export function setResetPwd(params) {
  return axios.post('/api/user/account/pwd/reset.do', qs.stringify(params));
}

// 管理员修改密码 
export function setChangePwd(params) {
  return axios.post('/api/user/account/pwd/change.do', qs.stringify(params));
}


// 获取当前登录人的基本信息
export function getCurrentInfo() {
  return axios.get('/api/admin/common/info.do')
}